'use strict';

var _util = require('util');

var util = babelHelpers.interopRequireWildcard(_util);


var getMonthData = function getMonthData(defaultlbs) {
  // const key = 'AIzaSyDqGy15v21Le2YARsUqjnRGdp3sTzxrJMk';
  // const createGoogleScript = () => {
  //   var mapScript = document.createElement('script');
  //   mapScript.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=initMap&libraries=geometry`;
  //   mapScript.async = 'ture';
  //   mapScript.type = 'text/javascript';
  //   document.body.appendChild(mapScript);
  // };

  // window.initMap = function () {
  //   log('init google map');
  //   var GoogleMap = window.google;
  //   var defaultlbs = defaultlbs || {lat: -6.2248451, lng: 106.8255324};
  //   const GoogleMapInstance = new GoogleMap.maps.Map(document.getElementById('google-map-location'), {zoom: 18, center: defaultlbs, zoomControl: true, scaleControl: true, zoomControlOptions: {
  //     position: GoogleMap.maps.ControlPosition.RIGHT_TOP}, streetViewControl: false, mapTypeControl: false});
  //   var myMark = new GoogleMap.maps.Marker({position: defaultlbs, map: GoogleMapInstance});
  // };
  // init google map
  // createGoogleScript();
  // 新增月度响应数据
  util.Ajax.get({
    url: 'https://appgw.kredito.id/website/config/list?configGroup=lending-page',
    headers: { 'Content-type': 'application/json' },
    _guestTokenRequest: true
  }).then(function (_ref) {
    var data = _ref.data;

    $('#data .tbk_90').text(data.tkb_90);
    $('#data .total_lender').text(data.total_lender);
    $('#data .lender_active').text(data.lender_active);
    $('#data .total_funding').text(data.total_funding);
    $('#data .current_funding').text(data.current_funding);
    $('#data .total_loan').text(data.total_loan);
    $('#data .current_loan').text(data.current_loan);
    $('#data .total_borrower').text(data.total_borrower);
    $('#data .current_borrower').text(data.current_borrower);
    $('#data .outstanding_funding').text(data.outstanding_funding);
    //
    $('.showOjk-wrap .tkb_90').text(data.tkb_90);
    $('.showOjk-wrap .l_tkb_0').text(data.l_tkb_0);
    $('.showOjk-wrap .l_tkb_30').text(data.l_tkb_30);
    $('.showOjk-wrap .l_tkb_60').text(data.l_tkb_60);
    $('.showOjk-wrap .l_tkb_90').text(data.l_tkb_90);
  });
}; /*
    * @Author: wellington wellington@kreditme.id
    * @Date: 2021-10-25 13:54:43
    * @LastEditors: wellington wellington@kreditme.id
    * @LastEditTime: 2024-10-29 16:44:14
    * @FilePath: /webui-official-website/src/webui-official-website/js/util/google-map.js
    * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
    */
// google map

getMonthData();

$('.app-wrapper').on('click', '.icon-wrap', function () {
  !$('.main-menu').is(':animated') && $('.main-menu').slideToggle();
}).on('click', '.back-to-top', function () {
  $('html,body').animate({ scrollTop: 0 }, 'slow');
}).on('click', '.main-menu a', function (e) {
  $('.tkb-drop').hide();
  if ($(e.target).attr('data-set') == 'intro') {
    $('.produk-pinjaman').hide();
    $('.faq').hide();
    $('.tentang-kami').slideToggle();
  } else if ($(e.target).attr('data-set') == 'intro2') {
    $('.tentang-kami').hide();
    $('.faq').hide();
    $('.produk-pinjaman').slideToggle();
  } else if ($(e.target).attr('data-set') == 'faq') {
    $('.tentang-kami').hide();
    $('.produk-pinjaman').hide();
    $('.faq').slideToggle();
  } else if ($('.bar').css('visibility') === 'visible') {
    $('.main-menu').hide();
  }

  if ($(this).data('scroll')) {
    var scrollHeight = $('#' + $(this).data('scroll')).offset().top - $('.header-section').height();
    $('html,body').animate({ scrollTop: scrollHeight }, 'slow');
  }
});

$('.app-wrapper').on('click', '.icon-notice-close', function () {
  $(this).modal('hide');
});

$('.app-wrapper').on('click', '.show-ojk', function () {
  $('.tentang-kami').hide();
  $('.produk-pinjaman').hide();
  $('.faq').hide();
  $('.tkb-drop').slideToggle('1000');
});